<template>
  <div class="-home-gallery-section">
    <div class="columns is-multiline">
      <GalleryItem
        v-for="item in artwork"
        :key="item.id"
        :imagePath="item.imagePath"
        :imageRef="item.imageRef"
        :imageTitle="item.title"
      />
    </div>
  </div>
</template>

<script>
import GalleryItem from "@/components/pages/home/GalleryItem.vue";

export default {
  name: "GallerySection",
  data() {
    return {
      artwork: [
        {
          id: 1,
          imagePath: require("@/assets/artwork/jpg/01.jpg"),
          title: "Kids See Ghosts",
          imageRef: "artwork-01"
        },
        {
          id: 2,
          imagePath: require("@/assets/artwork/jpg/02.jpg"),
          title: "Siblings",
          imageRef: "artwork-02"
        },
        {
          id: 3,
          imagePath: require("@/assets/artwork/jpg/03.jpg"),
          title: "Smoke Break",
          imageRef: "artwork-03"
        },
        {
          id: 4,
          imagePath: require("@/assets/artwork/jpg/04.jpg"),
          title: "Strange Cappucino",
          imageRef: "artwork-04"
        },
        {
          id: 5,
          imagePath: require("@/assets/artwork/jpg/05.jpg"),
          title: "Wraith",
          imageRef: "artwork-05"
        },
        {
          id: 6,
          imagePath: require("@/assets/artwork/jpg/06.jpg"),
          title: "Fortress",
          imageRef: "artwork-06"
        },
        {
          id: 7,
          imagePath: require("@/assets/artwork/jpg/07.jpg"),
          title: "Abe Sapien",
          imageRef: "artwork-07"
        },
        {
          id: 8,
          imagePath: require("@/assets/artwork/jpg/08.jpg"),
          title: "Beach Goth",
          imageRef: "artwork-08"
        },
        {
          id: 9,
          imagePath: require("@/assets/artwork/jpg/09.jpg"),
          title: "Leviathan",
          imageRef: "artwork-09"
        },
        {
          id: 10,
          imagePath: require("@/assets/artwork/jpg/10.jpg"),
          title: "Beastie",
          imageRef: "artwork-10"
        },
        {
          id: 11,
          imagePath: require("@/assets/artwork/jpg/11.jpg"),
          title: "The Thin White Duke",
          imageRef: "artwork-11"
        },
        {
          id: 12,
          imagePath: require("@/assets/artwork/jpg/12.jpg"),
          title: "Foliage Face",
          imageRef: "artwork-12"
        },
        {
          id: 13,
          imagePath: require("@/assets/artwork/jpg/13.jpg"),
          title: "Face",
          imageRef: "artwork-13"
        },
        {
          id: 14,
          imagePath: require("@/assets/artwork/jpg/14.jpg"),
          title: "Spotlight",
          imageRef: "artwork-14"
        },
        {
          id: 15,
          imagePath: require("@/assets/artwork/jpg/15.jpg"),
          title: "Perch",
          imageRef: "artwork-15"
        }
      ]
    };
  },
  components: {
    GalleryItem
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
